import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = sessionStorage.getItem("token"); // or use Context/Redux
  if (!token) {
    // Remember where they were going, so login can send them back there
    // (a shared lead link should open that lead, not the dashboard).
    const next = location.pathname + location.search;
    return <Navigate to={next && next !== "/" ? `/?next=${encodeURIComponent(next)}` : "/"} replace />;
  }
  return children;
};

export default ProtectedRoute;
